<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.0265 2.50511C16.3788 0.8434 14.3506 0 12 0C9.64852 0 7.61218 0.852466 5.94831 2.53049C4.32168 4.17096 3.5 6.19447 3.5 8.5468C3.5 9.7274 3.79361 11.0599 4.3707 12.5513C4.92657 13.9878 5.54565 15.2805 6.22906 16.4292C6.90159 17.5596 7.68414 18.7217 8.57661 19.916C9.46256 21.1016 10.0765 21.8927 10.4318 22.3048C10.5457 22.437 10.5463 22.4378 10.6718 22.5838C10.7951 22.7274 10.883 22.83 11.0587 23.0353L11.883 24L12.6498 23.3555C12.8469 23.1899 13.166 22.8681 13.5816 22.3651C14.1041 21.7328 14.7314 20.8921 15.4668 19.84C16.1985 18.7933 16.9378 17.6706 17.6849 16.4718C18.4564 15.2341 19.1132 13.9093 19.6553 12.4983C20.2153 11.041 20.5 9.72559 20.5 8.5468C20.5 6.19366 19.6693 4.16189 18.0265 2.50511ZM13.8184 18.7267C14.5297 17.709 15.2501 16.615 15.9795 15.4448C16.6846 14.3136 17.2862 13.1002 17.7843 11.8037C18.2646 10.5537 18.5 9.46625 18.5 8.54679C18.5 6.70343 17.871 5.16483 16.5943 3.8773C15.3225 2.59469 13.8105 1.96595 12 1.96595C10.1904 1.96595 8.66972 2.60254 7.38054 3.90268C6.12126 5.17269 5.5 6.70262 5.5 8.54679C5.5 9.46444 5.7433 10.5686 6.24004 11.8523C6.758 13.1909 7.33019 14.3856 7.95551 15.4367C8.59171 16.5061 9.33599 17.6114 10.1885 18.7522C11.0475 19.9018 11.6417 20.6674 11.9575 21.0337L12.0329 21.1212C12.5164 20.5356 13.1126 19.7364 13.8184 18.7267ZM9.4663 11.0994L9.51107 11.145C10.2001 11.8024 11.0471 12.1426 12 12.1426C12.9641 12.1426 13.813 11.7856 14.4881 11.0985C15.1567 10.4181 15.5 9.57287 15.5 8.61548C15.5 7.65808 15.1567 6.81282 14.4881 6.13245C13.813 5.4454 12.9641 5.08834 12 5.08834C11.0359 5.08834 10.187 5.4454 9.51187 6.13245C8.84331 6.81282 8.5 7.65808 8.5 8.61548C8.5 9.56212 8.82718 10.4056 9.4663 11.0994ZM13.0496 9.73268C12.7499 10.0377 12.4195 10.1767 12 10.1767C11.5797 10.1767 11.2383 10.0436 10.9273 9.75612C10.6377 9.43169 10.5 9.06594 10.5 8.61548C10.5 8.16477 10.6441 7.80997 10.9504 7.49827C11.2501 7.19324 11.5805 7.05428 12 7.05428C12.4195 7.05428 12.7499 7.19324 13.0496 7.49827C13.3559 7.80997 13.5 8.16477 13.5 8.61548C13.5 9.06618 13.3559 9.42098 13.0496 9.73268Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PlaceOutlineIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
